import { useMemo } from 'react';
import { getUserLobbyEliminationRecord } from '@/utils';

export function useEliminationStatus({
	lobby,
	user,
	hasSecondChanceTrades,
}: {
	lobby: any;
	user: any;
	hasSecondChanceTrades: boolean;
}) {
	const userEliminationInfo = useMemo(() => {
		if (!user?.id) {
			return { isUserEliminated: false, eliminatedRound: null };
		}
		if (!lobby?.id) {
			return { isUserEliminated: false, eliminatedRound: null };
		}

		const record = getUserLobbyEliminationRecord(lobby, user.id, lobby.id);

		if (!record) {
			return { isUserEliminated: false, eliminatedRound: null };
		}

		return {
			isUserEliminated: true,
			eliminatedRound: isNaN(Number(record.round)) ? null : Number(record.round),
		};
	}, [lobby?.eliminated_users, lobby?.id, user?.id]);

	const { isUserEliminated, eliminatedRound } = userEliminationInfo;

	const isUserRevived = useMemo(() => {
		if (isUserEliminated) return false;
		return lobby?.revived_users?.some((id: any) => String(id) === String(user?.id)) ?? false;
	}, [lobby?.revived_users, user?.id, isUserEliminated]);

	const isUserFinallyEliminated = useMemo(() => {
		return !!hasSecondChanceTrades && isUserEliminated;
	}, [hasSecondChanceTrades, isUserEliminated]);

	return { isUserEliminated, eliminatedRound, isUserRevived, isUserFinallyEliminated };
}
